<template>
  <div>
    <!-- 新认证用户引导弹窗  通过认证的用户，且尚未提交素材。首次进入用户侧时-->
    <bgModal
      ref="AuthenticationModal"
      width="480px"
      height="250px"
      :closable="false"
      :bodyStyle="{
        padding: 0,
        backgroundImage: `url(${require('@/assets/img/img_popup_03_bg.png')})`,
        backgroundSize: '100% 100%',
        height: '250px',
        borderRadius: '16px',
      }"
    >
      <div class="AuthenticationModal-content">
        <div class="title">
          <img src="@/assets/img/img_popup_02_bg.png" alt="" />
          <img src="@/assets/img/img_popup_01_bg.png" alt="" />
        </div>
        <p style="margin-bottom: 44px">
          亲爱的画师大大，恭喜通过认证，<br />
          现在可以进行素材上传啦！
        </p>
        <div class="agree-btn" style="text-align: center">
          <a-button
            type="primary"
            @click="showHelpModal"
            class="login-form-button"
            style="width: 120px; height: 40px; border-radius: 8px; margin: 0px auto 40px; font-size: 18px"
          >
            好的
          </a-button>
        </div>
      </div>
    </bgModal>
    <a-modal class="agree-modal" v-model="showHelp" :footer="null" width="760px" centered @cancel="cancelHelp">
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="title" slot="title">带你了解M Art素材</div>
      <div class="content">
        <p class="" style="margin: 8px 0 28px">M Art已开放素材上传功能，可以上传贴图和场景素材啦</p>
        <p>贴图：可以贴在人物或背景上的透明背景PNG图片称之为“贴图”。</p>
        <p style="margin-bottom: 28px">道具贴图示例：</p>
        <img src="@/assets/img/help_tool.jpg" alt="" />
        <p style="margin: 28px 0">人物贴图示例：</p>
        <img src="@/assets/img/help_person.jpg" alt="" />
        <p style="margin: 28px 0 20px">
          场景：一张完整的图片由多个物体组成，其中处于图片最底层的背景称之为“场景”。如：
        </p>
        <img src="@/assets/img/help_sence.jpg" alt="" />
        <p style="margin: 28px 0 20px">人设背景：即漫想世界APP人设空间内衬托二次元虚拟形象的背景图。如：</p>
        <img src="@/assets/img/img_help_bg.png" style="width: 280px" alt="" />
      </div>
      <div class="btn-list">
        <a-button
          type="default"
          @click="cancelHelp"
          class="login-form-button"
          style="width: 200px; height: 50px; border-radius: 8px; margin: 0px auto 40px"
        >
          以后再说
        </a-button>
        <a-button
          type="primary"
          @click="goUpload"
          class="login-form-button"
          style="width: 200px; height: 50px; border-radius: 8px; margin: 0px 0 40px 20px"
        >
          立即上传
        </a-button>
      </div>
    </a-modal>
    <!-- 新认证用户引导弹窗 end-->

    <!-- 更新弹窗  优先级最高-->
    <bgModal
      :closable="false"
      ref="updateModal"
      width="778px"
      height=""
      :bodyStyle="{
        padding: 0,
        backgroundImage: `url(${require('@/assets/img/img_renew_pop_ups_bg.png')})`,
        backgroundSize: '100% 100%',
        height: '522px',
      }"
    >
      <span class="close-modal-icon" slot="closeIcon" @click="updateHide"></span>
      <div class="update-title">M Art版本更新</div>
      <div class="update-content">
        <p class="desc">
          <span>1、新增『企划招募』功能：通过企划投稿作品，被选定的作品将获得更有针对性的投放销售和宣发。</span>
        </p>
        <p class="desc">
          <span>2、新增『人设背景』品类：可上传全新非人物素材类型，即漫想世界APP人设背景内衬托二次元形象的背景图。</span>
        </p>
        <p class="desc">以上功能都将持续更新，快来投稿作品体验下吧！</p>
        <p class="desc">M Art用户反馈群QQ号：784067577，欢迎加入。</p>
        <p class="desc" style="margin-top: 40px">
          <span style="text-align: right">M Art产品运营团队</span>
        </p>
      </div>
    </bgModal>

    <!-- 欢迎弹窗 未认证 每次重新打开网页都会弹-->
    <bgModal
      ref="wellcomeModal"
      width="480px"
      :bodyStyle="{
        padding: 0,
        backgroundImage: `url(${require('@/assets/img/img_successful_pop_ups_bg.png')})`,
        backgroundSize: '100% 100%',
        height: '480px',
      }"
    >
      <div class="wellcomeModal">
        <div class="content">
          <p class="desc" style="margin-bottom: 40px">距离成为素材画师还剩一步</p>
          <p class="title" style="margin-bottom: 22px">- 认证成功后，您将获得 -</p>
          <div style="line-height: 28px">
            <p class="desc" style="margin-bottom: 12px"><span style="color: #ff9e67">•</span> 简单便捷的素材售卖渠道</p>
            <p class="desc" style="margin-bottom: 12px"><span style="color: #ff9e67">•</span> 官方保障的素材交易流程</p>
            <p class="desc" style="margin-bottom: 12px"><span style="color: #ff9e67">•</span> 个人知名度提升</p>
          </div>
        </div>
        <div class="btn-list">
          <a-button
            type="default"
            class="cancel-btn"
            style=""
            @click="
              closeAuthentication()
              burry('39')
            "
            >先逛逛</a-button
          >
          <a-button
            type="default"
            @click="
              goAuthentication()
              burry('40')
            "
            class="confirm-btn"
            style=""
          >
            申请认证
          </a-button>
        </div>
      </div>
    </bgModal>

    <!-- 新注册-未认证引导弹窗
        通过认证用户：不弹新注册-未认证引导
        未通过认证用户：首次进入素材风向标页面时，弹出新注册-未认证引导。其中用户换浏览器/清缓存后，会再次弹出引导
    -->
    <bg-modal ref="guideModal" width="100%" :bodyStyle="{ height: '100vh' }">
      <div class="guidance" @click="guide_step" v-if="guide < 5">
        <div class="guide_1" v-if="guide == 1" :style="{ top: location1.top + 'px' }"></div>
        <div class="guide_2" v-if="guide == 2" :style="{ top: location2.top + 'px' }"></div>
        <div
          class="guide_3"
          v-if="guide == 3"
          :style="{ top: location3.top + 'px', right: location3.right + 'px' }"
        ></div>
        <div class="guide_4" v-if="guide == 4" :style="{ top: location4.top + 'px' }"></div>
      </div>
    </bg-modal>

  </div>
</template>

<script >
import bgModal from '@/components/Zpace/modal/bgModal'
import { mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {
      myChecked: false,
      showHelp: false,
      guide: 6,
      location1: {
        left: 0,
        top: 0
      },
      location2: {
        left: 0,
        top: 0
      },
      location3: {
        right: 29,
        top: 0
      },
      location4: {
        left: 0,
        top: 0
      }
    }
  },
  components: {
    bgModal

  },
  computed: {
    ...mapState({
      // 弹窗队列
      modalList: state => state.app.ModalList.split(',')
    }),
    userInfo () {
      return this.$store.state.user.info
    }
  },
  created () { },
  mounted () {

  },
  methods: {
    onChangeCheckbox (e) {
      this.myChecked = e.target.checked
    },
    async handleYesBtn () {
      if (!this.myChecked) {
        this.$message.error('请仔细阅读并勾选服务升级协议')
      } else {
        // ajax 保存同意状态
        const res = await this.$api.user.agree_change_body()
        if (res.status === 'ok') {
          localStorage.setItem('AGREE_SERVICE_CHANGE', 1)
          this.$nextTick(() => {
            this.showModalList()
          })
          // this.$store.dispatch('POP_MODAL_QUEUE')
        }
      }
    },
    guide_step () {
      this.guide = this.guide + 1
      if (this.guide >= 5) {
        this.$store.dispatch('POP_MODAL_QUEUE')
      }
    },
    showHelpModal () {
      this.$store.dispatch('POP_MODAL_QUEUE')
      this.showHelp = true
    },
    cancelHelp () {
      this.showHelp = false
    },
    goUpload () {
      this.showHelp = false
      this.$router.push({ path: '/texture/imageUpload' })
    },
    updateHide () {
      this.$store.dispatch('POP_MODAL_QUEUE')
    },
    closeAuthentication () {
      if (localStorage.getItem(`first_login_${this.userInfo.user_id}`) != this.userInfo.user_id) {
        localStorage.setItem(`first_login_${this.userInfo.user_id}`, this.userInfo.user_id)
        this.guide = 1
      }
      this.$store.dispatch('POP_MODAL_QUEUE')
    },
    goAuthentication () {
      this.$store.dispatch('POP_MODAL_QUEUE')
      this.$router.push({
        path: '/manage/userAuthentication'
      })
    },
    async showModalList () {
      // 显示更新弹窗
      if (!localStorage.getItem(`first_update_${this.userInfo.user_id}_${this.constv.VERSION}`)) {
        localStorage.setItem(`first_update_${this.userInfo.user_id}_${this.constv.VERSION}`, this.userInfo.user_id)
        // this.$store.dispatch('ADD_MODAL_QUEUE', 'updateModal')
      }

      // 欢迎弹窗
      if (this.$route.path === '/manage/materialDirection' && this.userInfo.authentication_status == '0' && !sessionStorage.getItem('isAuthentication')) {
        this.burry('38')
        sessionStorage.setItem('isAuthentication', 1)
        this.$store.dispatch('ADD_MODAL_QUEUE', 'wellcomeModal')
      }
      // 新手引导
      if (this.$route.path === '/manage/materialDirection' && this.userInfo.authentication_status != '2' && !localStorage.getItem(`first_guide_${this.userInfo.user_id}`)) {
        localStorage.setItem(`first_guide_${this.userInfo.user_id}`, this.userInfo.user_id)
        this.$nextTick(() => {
          setTimeout(() => {
            // 新手引导
            this.location1.top = document.querySelectorAll('.anticon-direction')[0].parentElement.parentElement.offsetTop
            this.location2.top = document.querySelectorAll('.anticon-help')[0].parentElement.parentElement.offsetTop
            this.location3.top = document.querySelectorAll('header')[0].offsetHeight
            this.location4.top = document.querySelectorAll('.anticon-pic')[0].parentElement.parentElement.offsetTop
          }, 0)
        })
        this.$store.dispatch('ADD_MODAL_QUEUE', 'guideModal')
        this.guide = 1
      }

      let count = 0
      if (!localStorage.getItem(`first_author_${this.userInfo.user_id}`)) {
        const res = await this.$api.texture.getTextureList({
          category: 0,
          status: 0,
          page: 1,
          pagesize: 12
        })
        this.spinning = false
        if (res.status === 'ok') {
          count = res.data.count
          if (count > 0) localStorage.setItem(`first_author_${this.userInfo.user_id}`, this.userInfo.user_id)

          sessionStorage.setItem('list', count)
          // 是否第一次认证成功
          if (this.userInfo.authentication_status == '2' && count <= 0 && !localStorage.getItem(`first_author_${this.userInfo.user_id}`)) {
            localStorage.setItem(`first_author_${this.userInfo.user_id}`, this.userInfo.user_id)
            this.$store.dispatch('ADD_MODAL_QUEUE', 'AuthenticationModal')
          }
        }
      }
    }
  },
  watch: {
    modalList (val, old) {
      console.log(val, old, val.length > old.length)
      if (val.length > old.length) {
        if (val[0]) this.$refs[val[0]].showModal()
      } else {
        if (old[0]) this.$refs[old[0]].hide()
        if (val[0]) {
          console.log(val)
          this.$refs[val[0]].showModal()
        }
      }
    },
    '$route': {
      handler () {
        if (!this.userInfo.user_id) return

        // 未登录时没有userInfo;已登录时，从弹窗跳转到了协议页面
        if (this.$route.path === '/agreement') {
          return

          // if (this.modalList.length > 0) {
          //   // 循环清除弹窗队列
          //   const arrLength = this.modalList.length
          //   for (let i = 0; i < arrLength; i++) {
          //     this.$store.dispatch('POP_MODAL_QUEUE')
          //   }
          //   return // 不再往下执行
          // }
        }

        //  判断，是否已同意服务升级
        if (parseInt(localStorage.getItem('AGREE_SERVICE_CHANGE')) === 0) {
          // 如果未同意状态，服务变更窗
          return
        }

        this.showModalList()
      }
    }
  }
}
</script>

<style lang='less' >
.agree-modal {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body {
    padding: 0 16px 0 44px;
    color: #343434;
    font-size: 16px;
    p {
      line-height: 28px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .content {
      height: 556px;
      overflow: auto;
      margin-top: 20px;
      padding-right: 28px;
    }
    .btn-list {
      text-align: center;
      margin-top: 42px;
    }
  }
}
.guidance {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 35;
  .guide_1 {
    position: fixed;
    background-image: url('../../../assets/img/img_step_1.png');
    z-index: 36;
    width: 478px;
    height: 251px;
    top: 30%;
  }
  .guide_2 {
    position: fixed;
    background-image: url('../../../assets/img/img_step_2.png');
    width: 423px;
    height: 237px;
    z-index: 36;
    top: 38%;
  }
  .guide_3 {
    position: fixed;
    background-image: url('../../../assets/img/img_step_3.png');
    width: 377px;
    height: 203px;
    top: 11.5%;
    right: 2.5%;
  }
  .guide_4 {
    position: fixed;
    background-image: url('../../../assets/img/img_step_4.png');
    width: 602px;
    height: 260px;
    top: 15.5%;
  }
}
</style>
